import { createContext } from "react";
import { SignInResult } from "@/repository/models";

export interface AuthState {
	isLogged: boolean;
	isInProgress: boolean;
	isLogoutInProgress: boolean;
	tenantId: string;
	userId: string;
	upn: string;
}

export interface AuthContextType extends AuthState {
	azureSignIn: (tenantId: string) => Promise<SignInResult>;
	msalSignIn: () => Promise<boolean>;
	signOut: () => void;
}

export const AuthContext = createContext<AuthContextType>(
	{} as AuthContextType
);
